var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2461 29.0205C16.7933 25.7688 15.851 23.203 14.1396 21.3125C12.3609 19.3477 9.81746 18.1807 6.33105 17.6699C11.5347 15.9192 15.5813 11.5348 17.0234 6.04883C18.5405 11.8195 22.9381 16.3712 28.5342 17.9209C23.1906 19.4006 18.9395 23.6179 17.2461 29.0205Z",
    stroke: "#C3AC89",
    strokeWidth: 1.11289
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1846 18.9453C17.0937 18.7411 16.9837 18.553 16.8506 18.3828C16.6406 18.1144 16.3877 17.9081 16.0967 17.7529C16.4677 17.4495 16.78 17.0639 17.0225 16.625C17.3116 17.1485 17.701 17.5956 18.1689 17.9189C17.7831 18.1857 17.4518 18.537 17.1846 18.9453Z",
    fill: "#C3AC89",
    stroke: "#C3AC89",
    strokeWidth: 1.11289
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.d3ea45516edb465aba757a77b3e97a2f.svg";
export { ForwardRef as ReactComponent };